module.exports = __webpack_public_path__ + "static/media/engine.3b5b201a.jpg";